import React, { useState, useEffect, useRef } from "react";

import { withRouter, Link } from "react-router-dom";

import Layout from "../../components/Layout";

import {apiCRMv3} from "../../services/api";

const UserCrmBranchData = (props) => {
    const [users, setUsers] = useState([]);
    const [usersToShow, setUsersToShow] = useState([])
    const [loaded, setLoaded] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [branchLongCode, setBranchLongCode] = useState("")
    const openModal = useRef(false)
    const [showModal, setShowModal] = useState(false);
    const [erro, setErro] = useState("");

    useEffect(() => {
        if (openModal.current) return;

        openModal.current = true;
        setShowModal(true);
        setLoaded(true);
    }, []);

    async function loadList(code = branchLongCode) {
        code = String(code ?? "").trim();

        if (!code) {
            setErro("Informe o código da filial.");
            setShowModal(true);
            return;
        }

        setErro("");
        setShowModal(false);
        setBranchLongCode(code.trim());
        setLoaded(false);

        const now = new Date();

        const formatDate = (date) =>
            `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

        const params = {
            start: formatDate(
                new Date(now.getFullYear(), now.getMonth(), 1)
            ),
            end: formatDate(
                new Date(now.getFullYear(), now.getMonth() + 1, 1)
            ),
            branchLongCode: code.trim(),
        };

        try {
            const response = await apiCRMv3.get(
                "/crm-analysis/crm-data-to-dash",
                { params }
            );

            const crm = response.data?.data?.crm;
            setUsers(Array.isArray(crm) ? crm : []);
            setUsersToShow(Array.isArray(crm) ? crm : [])
        } catch (error) {
            console.error("Erro na consulta:", error);

            setErro(
                error.response?.data?.message ||
                error.message ||
                "Não foi possível consultar a filial."
            );
            setShowModal(true);
        } finally {
            setLoaded(true);
        }
    }

    function handleSearchBar() {
        setLoaded(false);

        const usersList = users;
        if (searchText === "") {
            setUsersToShow(usersList);
            setLoaded(true);
            return;
        }

        let filteredUsers = usersList.filter(
            (users) =>
                String(users['Cpf Vendedor'] ?? "").includes(searchText)
        );

        setUsersToShow(filteredUsers);
        setLoaded(true);
    }


    return (
        <Layout
            menuActive="itens-crm-filial"
            pageTitle="Dados Filial"
            enableSearchBar={true}
            searchTerm={searchText}
            searchOnChange={(e) => setSearchText(e.target.value)}
            handleSearch={handleSearchBar}
        >
            <div className="row">
                <div className="col-xs-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">
                                Dados CRM Vendedores
                            </div>
                        </div>
                        <div
                            className={`card-body ${loaded ? "" : "__loading"}`}
                        >
                            <div className="loader-container text-center">
                                <div className="icon">
                                    <div className="sk-wave">
                                        <div className="sk-rect sk-rect1"></div>
                                        <div className="sk-rect sk-rect2"></div>
                                        <div className="sk-rect sk-rect3"></div>
                                        <div className="sk-rect sk-rect4"></div>
                                        <div className="sk-rect sk-rect5"></div>
                                    </div>
                                </div>
                                <div className="title">Carregando</div>
                            </div>

                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="table-responsive" style={{
                                        maxHeight: "70vh",
                                        overflowY: "auto",
                                        overflowX: "auto"
                                    }}>
                                        <table className="table table-striped table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "30%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Nome</th>
                                                    <th style={{ width: "30%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>CPF</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Aniversariantes Disponiveis</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Aniversariantes Enviados</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Intenções de Compra Disponiveis</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Intenções de Compra Enviados</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Funíl 2.0 Disponiveis</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Funíl 2.0 Enviados</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Funíl 2.0 Vencidos</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Pag. Ult. Parcelas Disponiveis</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Pag. Ult. Parcelas Enviados</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Pag. Ult. Parcelas Vencidos</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Garantias Disponiveis</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Garantias Enviados</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Remarketing Disponiveis</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Remarketing Enviados</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Remarketing Vencidos</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Inativos Disponiveis</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Inativos Enviados</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Lista Ativa Disponiveis</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Lista Ativa Enviados</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Lista Ativa Vencidos</th>
                                                    <th style={{ width: "10%", position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>Visitas Agendadas</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loaded && usersToShow.length === 0 ? (
                                                    <tr>
                                                        <td colSpan={12} className="text-center text-muted py-4">
                                                            Nenhum dado disponível para o período selecionado.
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    usersToShow.map((user, index) => (
                                                        <tr key={index}>
                                                            <td>{user['Nome Vendedor']}</td>
                                                            <td>{user['Cpf Vendedor']}</td>
                                                            <td>{user['Aniversariante Disponiveis']}</td>
                                                            <td>{user['Aniversariante Enviados']}</td>
                                                            <td>{user['Intenção de Compra Disponiveis']}</td>
                                                            <td>{user['Intenção de Compra Enviados']}</td>
                                                            <td>{user['Malas Diretas Disponiveis']}</td>
                                                            <td>{user['Malas Diretas Enviados']}</td>
                                                            <td>{user['Malas Diretas Vencidas']}</td>
                                                            <td>{user['Pagando Ultimas Parcelas Disponiveis']}</td>
                                                            <td>{user['Pagando Ultimas Parcelas Enviados']}</td>
                                                            <td>{user['Pagando Ultimas Parcelas Vencidos']}</td>
                                                            <td>{user['Garantia Elegível Disponiveis']}</td>
                                                            <td>{user['Garantia Elegível Enviados']}</td>
                                                            <td>{user['Remarketing Disponiveis']}</td>
                                                            <td>{user['Remarketing Enviados']}</td>
                                                            <td>{user['Remarketing Vencidos']}</td>
                                                            <td>{user['Inativos Disponiveis']}</td>
                                                            <td>{user['Inativos Enviados']}</td>
                                                            <td>{user['Listas Ativas Disponiveis']}</td>
                                                            <td>{user['Listas Ativas Enviados']}</td>
                                                            <td>{user['Listas Ativas Vencidas']}</td>
                                                            <td>{user['Visitas Agendadas']}</td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {showModal && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 1050,
                        background: "rgba(15, 23, 42, 0.65)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "20px",
                    }}
                >
                    <div
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="titulo-modal-filial"
                        style={{
                            width: "100%",
                            maxWidth: "420px",
                            background: "#fff",
                            borderRadius: "12px",
                            boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
                            overflow: "hidden",
                        }}
                    >
                        <div
                            style={{
                                padding: "24px 24px 12px",
                                borderBottom: "1px solid #eee",
                            }}
                        >
                            <h4
                                id="titulo-modal-filial"
                                style={{
                                    margin: 0,
                                    color: "#212529",
                                    fontSize: "21px",
                                    fontWeight: 600,
                                }}
                            >
                                Consultar filial
                            </h4>

                            <p
                                style={{
                                    margin: "8px 0 0",
                                    color: "#6c757d",
                                    fontSize: "14px",
                                }}
                            >
                                Informe o código da filial para carregar os dados do CRM.
                            </p>
                        </div>

                        <div style={{ padding: "24px" }}>
                            <label
                                htmlFor="branchLongCode"
                                style={{
                                    display: "block",
                                    marginBottom: "8px",
                                    fontWeight: 600,
                                    fontSize: "14px",
                                    color: "#343a40",
                                }}
                            >
                                Código da filial
                            </label>

                            <input
                                id="branchLongCode"
                                type="text"
                                value={branchLongCode}
                                placeholder="Ex.: 10002"
                                autoFocus
                                onChange={(e) => {
                                    setBranchLongCode(e.target.value);
                                    setErro("");
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        loadList(branchLongCode);
                                    }
                                }}
                                style={{
                                    width: "100%",
                                    height: "46px",
                                    padding: "10px 12px",
                                    border: erro
                                        ? "1px solid #dc3545"
                                        : "1px solid #ced4da",
                                    borderRadius: "6px",
                                    fontSize: "16px",
                                    boxSizing: "border-box",
                                    outline: "none",
                                }}
                            />

                            {erro && (
                                <p
                                    style={{
                                        color: "#dc3545",
                                        fontSize: "13px",
                                        margin: "8px 0 0",
                                    }}
                                >
                                    {erro}
                                </p>
                            )}
                        </div>

                        <div
                            style={{
                                padding: "0 24px 24px",
                            }}
                        >
                            <button
                                type="button"
                                onClick={() => loadList(branchLongCode)}
                                disabled={!loaded}
                                style={{
                                    width: "100%",
                                    height: "46px",
                                    border: "none",
                                    borderRadius: "6px",
                                    background: "#0d6efd",
                                    color: "#fff",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                    cursor: loaded ? "pointer" : "not-allowed",
                                    opacity: loaded ? 1 : 0.65,
                                }}
                            >
                                Consultar dados
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </Layout>
    );
};

export default withRouter(UserCrmBranchData);
